import { FC } from 'react'

import { usePortal } from '../../../../../../app/_providers/PortalProvider.client'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { AddToBagContainer } from '../../contexts/AddToBagContainer'
import { ProductDetailsContainer } from '../../contexts/ProductDetailsContainer'
import { EmbroiderySection } from '../EmbroiderySection'

import { ColorSection } from './ColorSection'
import { FitsSection } from './FitsSection'
import { SizesSection } from './SizesSection'
import * as Styles from './styles'

/**
 * The portal-specific attribute selectors that are displayed for the current product.
 */
export const PortalGarmentAttributes: FC = () => {
  const { isProductEmbroiderable, isProductOnWaitlist, portalColorGroups } =
    ProductDetailsContainer.useContainer()
  const { portal } = usePortal()

  const { resetInvalidBagClickStatus, addToBagErrors } = AddToBagContainer.useContainer()

  const {
    detailsSection: { portalPromoText },
  } = useTranslation()

  return (
    <>
      {portal?.discountPercentage && (
        <Styles.PortalPromoText data-testid='portal-promo-text'>{`${portal.discountPercentage}${portalPromoText}`}</Styles.PortalPromoText>
      )}
      <ColorSection colorGroups={portalColorGroups} retainColorGroupLabel />
      <SizesSection />
      <FitsSection />

      <EmbroiderySection
        isPortalColorSelected={true}
        embroiderable={isProductEmbroiderable && !isProductOnWaitlist}
        resetInvalidBagClickStatus={resetInvalidBagClickStatus}
        addToBagErrors={addToBagErrors}
      />
    </>
  )
}
